<template>
  <v-card class="rounded-card">
    <v-tabs v-model="tab">
      <v-tab>Detalhes</v-tab>
      <v-tab>Contatos</v-tab>
      <v-tab>Documentos</v-tab>
      <v-tab v-if="erpCamposIntegracao && hasCadastrosAdicionais">Campos Integração</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card class="rounded-card"
                flat
        >
          <v-card-text>
            <px-fornecedor-tab-detalhes :fornecedor="fornecedor"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card class="rounded-card" flat>
          <v-card-text>
            <px-fornecedor-tab-contato :fornecedor="fornecedor"
                                       @update="emitUpdate"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card class="rounded-card" flat>
          <v-card-text>
            <px-fornecedor-tab-documentos :fornecedor="fornecedor"
                                          @update="emitUpdate"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="erpCamposIntegracao && hasCadastrosAdicionais">
        <px-fornecedor-detalhes-tab-campos-integracao :fornecedor="fornecedor"
                                                      @update="emitUpdate"/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { getCadastroAdicional } from '@/utils/cadastros-adicionais-utils';
import FornecedorDetalhesTabCamposIntegracao
  from '@/modules/gestao-fornecedor/gestao/detalhes/FornecedorDetalhesTabCamposIntegracao.vue';
import FornecedorTabDetalhes from '../tabs/FornecedorTabDetalhes.vue';
import FornecedorTabContato from '../tabs/FornecedorTabContato.vue';
import FornecedorTabDocumentos from '../tabs/FornecedorTabDocumentos.vue';
import { initialStateCamposErp } from '../campos-erp/validate-campos-erp';

export default {
  props: {
    fornecedor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cadastrosAdicionais: null,
    };
  },
  computed: {
    ...mapGetters('entidade', ['erpCamposIntegracao']),
    tab: {
      get() {
        return this.$store.getters['gestaoFornecedores/tab'];
      },
      set(searchText) {
        this.$store.dispatch('gestaoFornecedores/tab', searchText);
      },
    },
    hasCadastrosAdicionais() {
      return !!this.cadastrosAdicionais;
    },
  },
  methods: {
    setupCadastrosAdicionais() {
      if (!this.cadastrosAdicionais) {
        return;
      }
      this.cadastrosAdicionais.natureza = getCadastroAdicional(this.fornecedor.cadastrosAdicionais, 'NATUREZA');
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
  created() {
    this.cadastrosAdicionais = initialStateCamposErp(this.erpCamposIntegracao);
    this.setupCadastrosAdicionais();
  },
  components: {
    pxFornecedorTabDetalhes: FornecedorTabDetalhes,
    pxFornecedorTabContato: FornecedorTabContato,
    pxFornecedorTabDocumentos: FornecedorTabDocumentos,
    pxFornecedorDetalhesTabCamposIntegracao: FornecedorDetalhesTabCamposIntegracao,
  },
};
</script>
